'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MoveButton = require('./components/MoveButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MoveButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/move-button/index.js
// module id = 1321
// module chunks = 0